import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReviewModel, ReviewResponseModel } from '@models/index'
import { WidgetNameDisplay } from '@enums/widgetNameDisplay.enum'
import { NgxPermissionsService } from 'ngx-permissions'
import { isFacebook } from '@utilities/function-utils'
import Swal from 'sweetalert2';
import { ReviewsFacadeService } from '@services/reviews/reviews-facade.service';

@Component({
  selector: 'incoming-review-2',
  templateUrl: './incoming-review-2.component.html',
  styleUrls: ['./incoming-review-2.component.sass']
})
export class IncomingReview2Component implements OnInit {
  @Input() name: string;
  @Input() lastName: string;
  @Input() reviewUrl: string;
  @Input() photo: string;
  @Input() starPercentage: number;
  @Input() reviewText: string;
  @Input() created: number;
  @Input() replies: ReviewResponseModel[];
  @Input() siteIcon: string;
  @Input() siteName: string;
  @Input() bgcolor: string;
  @Input() isFeedback: boolean;
  @Input() showShareIcon: boolean;
  @Input() isWidget: boolean;
  @Input() displayNameMode: string;
  @Input() isUnverified: boolean;
  @Input() truncateReview: boolean;
  @Input() location: string;
  @Input() locationName: string;
  @Input() numberOfAllowedReplies: number;
  @Input() showReplyButton: boolean;
  @Input() showEditReplyButton: boolean;
  @Input() integrationFlow: boolean;
  @Input() review: ReviewModel;
  @Input() isEnableOpenaiIntegration: boolean;
  @Input() messageHash: string;
  @Input() locationId: string;
  @Input() isSpam: boolean = false
  @Input() showSpamButton: boolean = false;
  @Input() pendingReply: {reviewId: string, reply: string}
  @Output() share = new EventEmitter();
  @Output() postReply = new EventEmitter<string>();
  @Output() deleteReply = new EventEmitter();
  @Output() trigerIntegration = new EventEmitter();

  showMore = false
  showReplyEditor = false;
  widgetNameDisplay = WidgetNameDisplay;

  permissions: any;

  isFacebook = isFacebook;

  constructor(
    private permissionsService: NgxPermissionsService,
    private reviewsFacadeService: ReviewsFacadeService,
  ) { }

  ngOnInit() {
    this.permissions = this.permissionsService.getPermissions();
    if(this.pendingReply) this.showReplyEditor = true;
   }

  textReplies() {
    return this.showMore ? 'Hide replies' : `Show ${this.replies.length} replies`
  }
  spamButtonClick() {
    const modalText = this.isSpam ? "Are you sure you want to mark this review as not spam?" : "Are you sure you want to mark this review as spam?"
    const modalTitle = this.isSpam ? "Mark Review as Not Spam" : "Mark Review as Spam"
    Swal.fire({
      title: modalTitle,
      text: modalText,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: "Cancel",
    }).then(result => {
      if (result.value) {
        this.isSpam = !this.isSpam
        this.reviewsFacadeService.markReviewSpam({
          locationId: this.locationId, messageHash: this.messageHash, isSpam: this.isSpam
        });
      }
    })
  }

  createPost(data: any) {
    if (this.integrationFlow) {
      this.trigerIntegration.emit()
    } else {
      this.postReply.emit(data);
    }
  }

  // dateFormat(timestamp: number): string {
  //   return moment(timestamp).isAfter(moment().subtract(7, 'days').unix() * 1000)
  //     ? 'Last 7 days'
  //     : moment(timestamp).isAfter(moment().subtract(30, 'days').unix() * 1000)
  //       ? 'Last 30 days'
  //       : moment(timestamp).format('M/D/YY, hh:mm A')
  // }
}
